export enum ForgotPasswordProps {
  IMAGE_ALT = 'Carbon one',
  HEADING = 'Forgot Password',
  SUBHEADING = 'Not to worry! We will send an OTP to your email to verify',
  BUTTON_LABEL_SUBMIT = 'Send',
  BUTTON_LABEL_BACK = 'Back',
}
